import { ref } from "vue"

export const useAuth = () => {
  const user = ref(window.user || null)

  return { user }
}
